import { auth } from '@/firebase';
import sl from '@/serviceLocator';
import { resetAdminBadge } from '@/utils';

const POLL_INTERVAL_MS = 1000 * 60 * 5;

let pollHandle: ReturnType<typeof setInterval> | null = null;

// The badge routes are admin-only, so refresh only while an admin is signed in.
const refreshIfAdmin = async () => {
  const store = sl.get('store');
  if (!auth.currentUser || !store.getters.isAdmin) {
    return;
  }
  try {
    await resetAdminBadge();
  } catch {
    // The badge is cosmetic: a failure, including a silent 401/403 from the
    // badge routes, waits for the next poll.
  }
};

export const stopAdminBadgePolling = () => {
  if (pollHandle !== null) {
    clearInterval(pollHandle);
    pollHandle = null;
  }
};

// Refresh the admin badge now and every five minutes. Calling it while a
// poll is running does nothing; sign-out stops the poll.
export const startAdminBadgePolling = (): Promise<void> => {
  if (pollHandle !== null) {
    return Promise.resolve();
  }
  pollHandle = setInterval(refreshIfAdmin, POLL_INTERVAL_MS);
  return refreshIfAdmin();
};
